import {VStack} from "@hosttools/frontend";
import type React from "react";
import {memo} from "react";

import Paragraph from "../Paragraph";

const texts = [
    "Host Tools will use your API key to automatically send messages to your guests or set your listing's prices and availability on your behalf. It will only send messages you tell it to send and will never make any changes to your account without your permission.",
    "All network traffic is encrypted on Host Tools and all data is stored using the latest compliance standards."
];

const HostToolPolicy: React.FC = () => {
    return (
        <VStack space="lg">
            {texts.map(text => (
                <Paragraph key={text} variant="sm">
                    {text}
                </Paragraph>
            ))}
        </VStack>
    );
};

export default memo(HostToolPolicy);
